/* eslint-disable object-curly-newline */
import React from "react";

import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";

import SompoCard from "./SompoCard";
import SompoCardBadge from "./SompoCardBadge";

import Thumbnail from "../../images/curriculum.png";

export interface CurriculumCardProps {
    tooltip?: string;
    height?: string;
    onClick?: React.MouseEventHandler<HTMLDivElement>;
    badge?: string;
    children?: React.ReactNode;
}

const NO_IMAGE = `url(${Thumbnail})`;

const CurriculumCard = (props: CurriculumCardProps) => {
    const { children, badge, onClick, tooltip, height = "305px" } = props;
    return (
        <Tooltip title={tooltip}>
            <SompoCard onClick={onClick} sx={{ height }}>
                <Box
                    sx={{
                        // minHeight: "130px",
                        backgroundImage: NO_IMAGE,
                        backgroundSize: "cover",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "flex-end",
                        borderTopLeftRadius: "7px",
                        borderTopRightRadius: "7px",
                        aspectRatio: "16/9",
                    }}
                >
                    {badge && <SompoCardBadge division={props.badge!} />}
                </Box>
                {children}
            </SompoCard>
        </Tooltip>
    );
};

export default CurriculumCard;
